import { useState } from 'react';
import { toast } from 'sonner';
import api from '../../lib/api';
import { Button } from '../ui/button';
import { Input } from '../ui/input';

// Staff: create a client-facing action for this task (the internal task itself is never shown to, or completed by, the client).
export const ClientActionForm = ({ taskId }) => {
  const [v, setV] = useState({ title: '', description: '', due_date: '', upload_required: false });
  const send = () => api.post(`/api/tasks/${taskId}/client-actions`, v).then(() => { toast.success('Client action sent to the portal'); setV({ title: '', description: '', due_date: '', upload_required: false }); })
    .catch((e) => toast.error(e.response?.data?.detail || 'Could not create'));
  return (
    <div className="space-y-2 rounded-lg border border-border p-3" data-testid="client-action-form">
      <p className="text-sm font-medium">Ask the client to do something</p>
      <Input placeholder="Title (what the client sees)" value={v.title} onChange={(e) => setV({ ...v, title: e.target.value })} data-testid="client-action-title" />
      <Input placeholder="Details (optional)" value={v.description} onChange={(e) => setV({ ...v, description: e.target.value })} data-testid="client-action-description" />
      <div className="flex flex-wrap items-center gap-3">
        <Input type="date" className="w-44" value={v.due_date} onChange={(e) => setV({ ...v, due_date: e.target.value })} data-testid="client-action-due" />
        <label className="flex items-center gap-2 text-sm"><input type="checkbox" checked={v.upload_required} onChange={(e) => setV({ ...v, upload_required: e.target.checked })} data-testid="client-action-upload-required" />Upload required</label>
        <Button size="sm" onClick={send} disabled={!v.title.trim()} data-testid="client-action-send">Send to client</Button>
      </div>
    </div>
  );
};
